// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mmo8","colBig":"styles_colBig__3zPy8","colSmall":"styles_colSmall__3wDwt"};